import { bl_t2t_item_to_item_link_RowClass, bl_t2t_item_to_item_link_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialItemLinkingContainerModel extends BaseContainerModel {
  bl_t2t_item_to_item_link: bl_t2t_item_to_item_link_RowInterface = new bl_t2t_item_to_item_link_RowClass();

}

export class FinancialItemLinkingQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  status: string;
}
